import { type MutationHookOptions, useMutation } from "@apollo/client";
import { AssignSupportRequestMutation } from "../graphql/mutations";
import type {
  AssignSupportRequestMutationType,
  AssignSupportRequestMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useAssignSupportRequestMutation = (
  options?: MutationHookOptions<
    AssignSupportRequestMutationType,
    AssignSupportRequestMutationVariablesType
  >
) =>
  useMutation<
    AssignSupportRequestMutationType,
    AssignSupportRequestMutationVariablesType
  >(AssignSupportRequestMutation, options);
